import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from "../../../../core/components/core/Util/Form/CustomForm/CustomForm";
import CustomFormContainer from "../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer";
import { getUserSession } from "../../../../core/util/core/Session";
import Fetch from "../../../../core/util/core/Fetch";
import config from '../../../../application/config/config';

function Form() {


    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const session = getUserSession();

    const pathFrontEnd = '/core/support/';
    const pathBackEnd = 'core/supportrequests/';
    const paths = {
        endpointSave: config.endpoints.backend + pathBackEnd + 'save',
        endpointGetById: config.endpoints.backend + pathBackEnd + 'getById',
        urlGoBack: pathFrontEnd + 'list',
        pathView: pathFrontEnd + 'view'
    }


    const labels = {
        labelTitleAdd: "Novo Chamado",
        labelTitleEdit: "Editar Chamado",
        labelTitleView: 'Visualizar Chamado'
    }


    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                core_application_instance_id: session.user.application_instance_id,
                core_user_id: session.user.id,
            },
            fields: [
                {
                    name: 'core_support_incidence_id',
                    type: 'select',
                    options: [],
                    optionsEndpoint: {
                        endpoint: config.endpoints.backend + 'core/supportincidences/getall',
                        label: 'name',
                        value: 'id',
                    },
                    label: 'Incidência',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'title',
                    type: 'text',
                    label: 'Título',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'message',
                    type: 'textarea',
                    label: 'Mensagem',
                    maxLength: 500,
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                },
                {
                    name: 'files',
                    type: 'multiUploadFileS3',
                    label: 'Anexar arquivos (Observação: máximo de 20 arquivos de 10MB)',
                    uploadPath: 'support',
                    extensionAccept: '.jpeg,.jpg,.png,.pdf',
                    limitFileSize: 10,
                    uploadFileLimit: 20,
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                },
            ],
            ...paths,
            ...labels
        }

        form.values = values;
        return form;
    }


    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])


    return (
        <>
            <div>
                {formContent}
            </div>
        </>
    );
}
export default Form;


